<i18n locale="en">
{
  "actions": {
    "confirm": "Save Image"
  },
  "source": {
    "label": "Image Source",
    "description": "Where did you get this image from?"
  },
  "type": {
    "label": "Image type",
    "description": "Was this image AI-processed?",
    "original": "Original (not AI-processed)",
    "ai-upscaled": "AI-enhanced",
    "ai-generated": "AI-generated"
  },
  "dialogs": {
    "title": "Save Image"
  }
}
</i18n>
<template>
  <ConfirmDialog
    :model-value="modelValue"
    :title="t('dialogs.title')"
    :confirm-label="t('actions.confirm')"
    :processing="processing"
    @update:model-value="$emit('update:modelValue', $event)"
    @confirm="$emit('confirm')"
    @cancel="$emit('cancel')"
  >
    <div class="flex-col gap-3">
      <OwnInputContainer
        :label="t('source.label')"
        :description="t('source.description')"
      >
        <OwnSelect
          :model-value="selectedSource"
          :options="sourceOptions"
          :placeholder="$t('image-sources.customer-web')"
          @update:model-value="$emit('update:selectedSource', $event)"
        />
      </OwnInputContainer>

      <OwnInputContainer
        :label="t('type.label')"
        :description="t('type.description')"
      >
        <OwnSelect
          :model-value="selectedType"
          :options="typeOptions"
          @update:model-value="$emit('update:selectedType', $event)"
        />
      </OwnInputContainer>
    </div>
  </ConfirmDialog>
</template>
<script lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { OwnSelect } from '@/ui/OwnSelect'

export default {
  name: 'ImageSourceDialog',
  components: {
    ConfirmDialog,
    OwnInputContainer,
    OwnSelect,
  },
  emits: [
    'update:modelValue',
    'update:selectedSource',
    'update:selectedType',
    'confirm',
    'cancel',
  ],
  setup() {
    const { t } = useI18n()

    const sourceOptions = computed(() => [
      { label: t('image-sources.customer-web'), value: 'customer-web' },
      { label: t('image-sources.freepik'), value: 'freepik' },
      { label: t('image-sources.third-party-dd'), value: 'third-party-dd' },
      { label: t('image-sources.third-party-gh'), value: 'third-party-gh' },
      {
        label: t('image-sources.third-party-other'),
        value: 'third-party-other',
      },
      { label: t('image-sources.third-party-ue'), value: 'third-party-ue' },
      { label: t('image-sources.slice'), value: 'slice' },
      { label: t('image-sources.snappr'), value: 'snappr' },
      { label: t('image-sources.unknown'), value: 'unknown' },
    ])

    const typeOptions = computed(() => [
      { label: t('type.original'), value: 'original' },
      { label: t('type.ai-upscaled'), value: 'ai-upscaled' },
      { label: t('type.ai-generated'), value: 'ai-generated' },
    ])

    return { sourceOptions, t, typeOptions }
  },
  props: {
    modelValue: { type: Boolean, default: false },
    processing: { type: Boolean, default: false },
    selectedSource: { type: String, default: 'customer-web' },
    selectedType: { type: String, default: 'original' },
  },
}
</script>
